export enum ROUTE_ADMIN {
  ADMIN_TENANT = 'admin-tenant',
  ADMIN_TENANT_FACET = 'admin-tenant-facet'
}